import { useState } from 'react'
import emailjs from '@emailjs/browser'
import './ContactSection.css'

const EMAILJS_CONFIG = {
  serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  adminTemplateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  userTemplateId: process.env.REACT_APP_EMAILJS_TEMPLATE_USER_ID,
  publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
}

const SPECIES = [
  'Chien', 'Chat', 'Oiseau', 'Lapin', 'Rongeur',
  'Reptile', 'Poisson', 'Cheval', 'Autre',
]

const REGIONS = [
  'Île-de-France', "Provence-Alpes-Côte d'Azur", 'Auvergne-Rhône-Alpes',
  'Nouvelle-Aquitaine', 'Occitanie', 'Bretagne', 'Normandie',
  'Hauts-de-France', 'Grand Est', 'Pays de la Loire', 'Autre',
]

const IconPhone = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.36 13.4 19.79 19.79 0 0 1 1.15 4.84 2 2 0 0 1 3.12 2.68h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 10a16 16 0 0 0 6.29 6.29l1.42-1.42a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 17z"/>
  </svg>
)
const IconMail = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
)
const IconPin = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
)
const IconChevron = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"/>
  </svg>
)
const IconPaw = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="5.5" cy="9" rx="2" ry="2.8"/>
    <ellipse cx="18.5" cy="9" rx="2" ry="2.8"/>
    <ellipse cx="9" cy="6" rx="2.2" ry="3"/>
    <ellipse cx="15" cy="6" rx="2.2" ry="3"/>
    <path d="M12 13c-3.5 0-6.5 2-6.5 4.5 0 1.8 1.5 3 3 3 1 0 2-.5 3.5-.5s2.5.5 3.5.5c1.5 0 3-1.2 3-3C18.5 15 15.5 13 12 13z"/>
  </svg>
)
const IconArrow = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
)
const IconShield = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
)
const IconCheck = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
)

const Req = () => <span className="cs-required">*</span>

const CONTACTS_INFO = [
  { Icon: IconPhone, label: 'Téléphone',   value: '+33 07 57 75 00 92' },
  { Icon: IconMail,  label: 'Email',       value: 'animauxdecompagnie@animauxpouradoptiondelafrance.com' },
  { Icon: IconPin,   label: 'Adresse',     value: 'Paris, France' },
]

const TRUST_ITEMS = [
  'Réponse garantie sous 24h ouvrées',
  'Données traitées de façon confidentielle',
  'Conseils personnalisés gratuits',
]

// ── Règles de validation par champ ──────────────────────────
const RULES = {
  name:    v => !v.trim()                           ? 'Le nom complet est requis.' : v.trim().length < 2 ? 'Le nom doit contenir au moins 2 caractères.' : '',
  phone:   v => !v.trim()                           ? 'Le téléphone est requis.' : !/^[+\d][\d\s\-().]{6,19}$/.test(v.trim()) ? 'Format invalide (ex : +33 6 00 00 00 00).' : '',
  email:   v => !v.trim()                           ? "L'email est requis." : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()) ? 'Adresse email invalide.' : '',
  species: v => !v                                   ? "L'espèce est requise." : '',
  breed:   v => !v.trim()                           ? 'La race / espèce précise est requise.' : '',
  weight:  v => v !== '' && (isNaN(Number(v)) || Number(v) < 0) ? 'Poids invalide.' : '',
  region:  v => !v                                   ? 'La région est requise.' : '',
  notes:   () => '',
}

export default function ContactSection() {
  const [form, setForm] = useState({
    name: '', phone: '', email: '',
    species: '', breed: '', weight: '',
    region: '', notes: '',
  })
  // touched: tracks which fields the user has interacted with
  const [touched, setTouched] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [status, setStatus] = useState('idle')
  const [submitError, setSubmitError] = useState('')

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }))
  const touch = (k) => () => setTouched(t => ({ ...t, [k]: true }))

  // Compute error for a field (show only if touched or after submit attempt)
  const err = (k) => (touched[k] || submitted) ? RULES[k](form[k]) : ''

  const allValid = () => Object.keys(RULES).every(k => !RULES[k](form[k]))

  const handleSubmit = async () => {
    setSubmitted(true)
    setSubmitError('')
    // Mark all fields touched so errors show up
    setTouched(Object.keys(RULES).reduce((a, k) => ({ ...a, [k]: true }), {}))
    if (!allValid()) return
    setStatus('sending')

    try {
      const missingConfig = Object.values(EMAILJS_CONFIG).some(value => !value)
      if (missingConfig) throw new Error('Configuration EmailJS incomplète')

      const templateParams = {
        user_name: form.name.trim(),
        user_email: form.email.trim(),
        user_phone: form.phone.trim(),
        espece: form.species,
        race: form.breed.trim(),
        poids: form.weight || 'Non renseigné',
        search: form.region,
        message: form.notes.trim() || 'Aucune information complémentaire.',
        reply_to: form.email.trim(),
      }

      await Promise.all([
        emailjs.send(
          EMAILJS_CONFIG.serviceId,
          EMAILJS_CONFIG.adminTemplateId,
          templateParams,
          { publicKey: EMAILJS_CONFIG.publicKey }
        ),
        emailjs.send(
          EMAILJS_CONFIG.serviceId,
          EMAILJS_CONFIG.userTemplateId,
          templateParams,
          { publicKey: EMAILJS_CONFIG.publicKey }
        ),
      ])

      setStatus('success')
      setForm({ name: '', phone: '', email: '', species: '', breed: '', weight: '', region: '', notes: '' })
      setTouched({})
      setSubmitted(false)
    } catch (error) {
      setStatus('error')
      setSubmitError("L'envoi a échoué. Veuillez réessayer dans quelques instants.")
      console.error('EmailJS contact form:', error)
    }
  }

  const inputCls = (k) => `cs-input${err(k) ? ' cs-input--err' : ''}`
  const selectCls = (k) => `cs-select${err(k) ? ' cs-input--err' : ''}`

  return (
    <section className="cs-section" id="contact">
      <div className="cs-inner">

        {/* ── Colonne gauche ── */}
        <div className="cs-left">
          <div className="cs-eyebrow">
            <span className="cs-eyebrow-line" />
            NOUS CONTACTER
          </div>
          <h2 className="cs-title">
            Vous avez une<br />
            question sur<br />
            <span className="cs-title-accent">une adoption ?</span>
          </h2>
          <p className="cs-desc">
            Remplissez ce formulaire et un conseiller vous contacte
            sous 24h avec des informations personnalisées et des
            conseils adaptés à votre situation.
          </p>

          <div className="cs-contacts">
            {CONTACTS_INFO.map(({ Icon, label, value }) => (
              <div className="cs-contact-item" key={label}>
                <span className="cs-contact-icon"><Icon /></span>
                <div>
                  <div className="cs-contact-label">{label}</div>
                  <div className="cs-contact-value">{value}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="cs-trust">
            {TRUST_ITEMS.map(t => (
              <div className="cs-trust-item" key={t}>
                <span className="cs-trust-icon"><IconCheck /></span>
                {t}
              </div>
            ))}
          </div>
        </div>

        {/* ── Colonne droite : formulaire ── */}
        <div className="cs-right">
          {status === 'success' ? (
            <div className="cs-success">
              <div className="cs-success-icon">🐾</div>
              <h3>Message envoyé !</h3>
              <p>Merci pour votre demande. Notre équipe vous répondra dans les 24 heures ouvrées.</p>
              <button className="cs-success-btn" onClick={() => setStatus('idle')}>
                Envoyer une autre demande
              </button>
            </div>
          ) : (
            <>
              {/* Bloc 01 — Coordonnées */}
              <div className="cs-block">
                <div className="cs-block-title">
                  <span className="cs-block-num">01</span>
                  Vos coordonnées
                </div>
                <div className="cs-row-2">
                  <div className="cs-field">
                    <label className="cs-label">Nom complet <Req /></label>
                    <input
                      className={inputCls('name')}
                      placeholder="Jean Dupont"
                      value={form.name}
                      onChange={set('name')}
                      onBlur={touch('name')}
                    />
                    {err('name') && <span className="cs-field-err">{err('name')}</span>}
                  </div>
                  <div className="cs-field">
                    <label className="cs-label">Téléphone <Req /></label>
                    <input
                      className={inputCls('phone')}
                      placeholder="+33 6 00 00 00 00"
                      value={form.phone}
                      onChange={set('phone')}
                      onBlur={touch('phone')}
                    />
                    {err('phone') && <span className="cs-field-err">{err('phone')}</span>}
                  </div>
                </div>
                <div className="cs-field">
                  <label className="cs-label">Adresse email <Req /></label>
                  <input
                    className={inputCls('email')}
                    type="email"
                    placeholder="jean@exemple.com"
                    value={form.email}
                    onChange={set('email')}
                    onBlur={touch('email')}
                    required
                  />
                  {err('email') && <span className="cs-field-err">{err('email')}</span>}
                </div>
              </div>

              {/* Bloc 02 — Animal */}
              <div className="cs-block">
                <div className="cs-block-title">
                  <span className="cs-block-num">02</span>
                  L'animal recherché
                </div>
                <div className="cs-row-2">
                  <div className="cs-field">
                    <label className="cs-label">Espèce <Req /></label>
                    <div className="cs-select-wrap">
                      <select
                        className={selectCls('species')}
                        value={form.species}
                        onChange={set('species')}
                        onBlur={touch('species')}
                        required
                      >
                        <option value="">Sélectionner…</option>
                        {SPECIES.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                      <span className="cs-select-icon"><IconChevron /></span>
                    </div>
                    {err('species') && <span className="cs-field-err">{err('species')}</span>}
                  </div>
                  <div className="cs-field">
                    <label className="cs-label">Race / Espèce précise <Req /></label>
                    <input
                      className={inputCls('breed')}
                      placeholder="Labrador, Bengal…"
                      value={form.breed}
                      onChange={set('breed')}
                      onBlur={touch('breed')}
                      required
                    />
                    {err('breed') && <span className="cs-field-err">{err('breed')}</span>}
                  </div>
                </div>
                <div className="cs-field cs-field--half">
                  <label className="cs-label">Poids approximatif (kg)</label>
                  <input
                    className={inputCls('weight')}
                    type="number"
                    min="0"
                    placeholder="ex : 12"
                    value={form.weight}
                    onChange={set('weight')}
                    onBlur={touch('weight')}
                  />
                  {err('weight') && <span className="cs-field-err">{err('weight')}</span>}
                </div>
              </div>

              {/* Bloc 03 — Localisation */}
              <div className="cs-block">
                <div className="cs-block-title">
                  <span className="cs-block-num">03</span>
                  Votre région
                </div>
                <div className="cs-field">
                  <label className="cs-label">Région de recherche <Req /></label>
                  <div className="cs-select-wrap">
                    <select
                      className={selectCls('region')}
                      value={form.region}
                      onChange={set('region')}
                      onBlur={touch('region')}
                    >
                      <option value="">Sélectionner une région…</option>
                      {REGIONS.map(r => <option key={r} value={r}>{r}</option>)}
                    </select>
                    <span className="cs-select-icon"><IconChevron /></span>
                  </div>
                  {err('region') && <span className="cs-field-err">{err('region')}</span>}
                </div>
                <div className="cs-field cs-field--notes">
                  <label className="cs-label">Informations complémentaires</label>
                  <textarea
                    className="cs-textarea"
                    placeholder="Budget, délai souhaité, critères particuliers, questions…"
                    value={form.notes}
                    onChange={set('notes')}
                    rows={4}
                  />
                </div>
              </div>

              {submitError && <p className="cs-field-err" role="alert">{submitError}</p>}
              <button
                className="cs-submit"
                onClick={handleSubmit}
                disabled={status === 'sending'}
              >
                {status === 'sending' ? (
                  <><span className="cs-spinner" /> Envoi en cours…</>
                ) : (
                  <><IconPaw /> Envoyer ma demande <IconArrow /></>
                )}
              </button>

              <div className="cs-footer-note">
                <IconShield />
                Champs obligatoires <Req />. Réponse garantie sous 24h ouvrées.
              </div>
            </>
          )}
        </div>

      </div>
    </section>
  )
}